// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DocumentCreateCommandFromJSON(json) {
    return {
        'documentID': !exists(json, 'documentID') ? undefined : json['documentID'],
        'propertyID': !exists(json, 'propertyID') ? undefined : json['propertyID'],
        'projectID': !exists(json, 'projectID') ? undefined : json['projectID'],
        'costID': !exists(json, 'costID') ? undefined : json['costID'],
        'taskID': !exists(json, 'taskID') ? undefined : json['taskID'],
        'rfpid': !exists(json, 'rfpid') ? undefined : json['rfpid'],
        'rfpTemplateID': !exists(json, 'rfpTemplateID') ? undefined : json['rfpTemplateID'],
        'meetingID': !exists(json, 'meetingID') ? undefined : json['meetingID'],
        'reqID': !exists(json, 'reqID') ? undefined : json['reqID'],
        'costHeaderID': !exists(json, 'costHeaderID') ? undefined : json['costHeaderID'],
        'docType': !exists(json, 'docType') ? undefined : json['docType'],
        'docCategory': !exists(json, 'docCategory') ? undefined : json['docCategory'],
        'docName': !exists(json, 'docName') ? undefined : json['docName'],
        'docDescription': !exists(json, 'docDescription') ? undefined : json['docDescription'],
        'docStatus': !exists(json, 'docStatus') ? undefined : json['docStatus'],
        'docStatusDate': !exists(json, 'docStatusDate') ? undefined : new Date(json['docStatusDate']),
        'documentContainerFileName': !exists(json, 'documentContainerFileName') ? undefined : json['documentContainerFileName'],
        'documentBinaryData': !exists(json, 'documentBinaryData') ? undefined : json['documentBinaryData'],
        'documentLocation': !exists(json, 'documentLocation') ? undefined : json['documentLocation'],
        'folderNodeParentId': !exists(json, 'folderNodeParentId') ? undefined : json['folderNodeParentId'],
        'cloudDocumentType': !exists(json, 'cloudDocumentType') ? undefined : json['cloudDocumentType'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}
export function DocumentCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'documentID': value.documentID,
        'propertyID': value.propertyID,
        'projectID': value.projectID,
        'costID': value.costID,
        'taskID': value.taskID,
        'rfpid': value.rfpid,
        'rfpTemplateID': value.rfpTemplateID,
        'meetingID': value.meetingID,
        'reqID': value.reqID,
        'costHeaderID': value.costHeaderID,
        'docType': value.docType,
        'docCategory': value.docCategory,
        'docName': value.docName,
        'docDescription': value.docDescription,
        'docStatus': value.docStatus,
        'docStatusDate': value.docStatusDate === undefined ? undefined : value.docStatusDate.toISOString(),
        'documentContainerFileName': value.documentContainerFileName,
        'documentBinaryData': value.documentBinaryData,
        'documentLocation': value.documentLocation,
        'folderNodeParentId': value.folderNodeParentId,
        'cloudDocumentType': value.cloudDocumentType,
        'createdBy': value.createdBy,
        'modifiedBy': value.modifiedBy,
    };
}
